import './FormLayout.css'

function FormSection({ label, children }) {
    return (
        <div className="fl-section">
            {label && <span className="fl-section-label">{label}</span>}
            <div className="fl-section-body">
                {children}
            </div>
        </div>
    )
}

export default FormSection
